module.exports = __webpack_public_path__ + "img/nav.798f4db1.jpeg";